/**
 * Removes all characters except digits.
 *
 * @example
 * allowOnlyDigits('123abc') // '123'
 * allowOnlyDigits('$9,000.00') // '900000'
 * allowOnlyDigits('Phone: +91-98765 43210') // '919876543210'
 */
export const allowOnlyDigits = (input: string): string => input.replace(/\D/g, '');

/**
 * Removes all characters except digits, commas, and periods.
 *
 * @example
 * allowDigitsCommaDot('12,345.67') // '12,345.67'
 * allowDigitsCommaDot('$1,000.50 USD') // '1,000.50'
 * allowDigitsCommaDot('abc123.45def,678') // '123.45,678'
 */
export const allowDigitsCommaDot = (input: string): string => input.replace(/[^0-9,.]/g, '');
